module.exports = __webpack_public_path__ + "media/icons/player6-5aeaac10.png";